import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import DownloadCardStyles from '@stories/Components/Cards/DownloadCard/DownloadCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --sectionSpacingTop: 48px;
  --sectopmSpacingBottom: ${fluid(0, 48)};

  @media ${from(Device.TabletLarge)} {
    --sectionSpacingTop: ${fluid(26, 32)};
  }

  @media print {
    display: none;
  }

  ${SectionWrapperStyles.Inner} {
    @media ${until(866)} {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;
const Grid = styled.div `
  [data-multi-column='true'] & {
    display: flex;
    flex-direction: column;
    gap: ${fluid(16, 32)};

    @media ${from(Device.TabletLarge)} {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }
`;
const Card = styled.div `
  [data-multi-column='true'] & {
    ${DownloadCardStyles.Grid} {
      display: flex;
      flex-direction: column;
      padding: ${fluid(40, 42)} ${fluid(16, 32)} ${fluid(40, 80)};
    }

    ${DownloadCardStyles.ContentArea} {
      align-self: flex-start;
    }

    ${DownloadCardStyles.ImageArea} {
      max-width: 470px;
    }
  }
`;
const DownloadCardsStyles = {
    Card,
    Container,
    Grid,
};
export default DownloadCardsStyles;
